import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
    { to: '/', label: 'Home' },
    { to: '/news', label: 'News Feed' },
    { to: '/chat', label: 'Live Chat' },
    { to: '/airline', label: 'Airline Project' }
];

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);

    return (
        <nav className="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top site-navbar" id="mainNav">
            <div className="container">
                <Link className="navbar-brand" to="/">
                    Shaurya Kala
                </Link>
                <button
                    className="navbar-toggler text-uppercase font-weight-bold bg-primary text-white rounded"
                    type="button"
                    aria-controls="navbarResponsive"
                    aria-expanded={isMenuOpen}
                    aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
                    onClick={() => setIsMenuOpen((open) => !open)}
                >
                    <span>Menu</span>
                    <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`} aria-hidden="true"></i>
                </button>
                <div
                    className={`collapse navbar-collapse site-navbar-collapse${isMenuOpen ? ' show' : ''}`}
                    id="navbarResponsive"
                >
                    <ul className="navbar-nav ms-auto">
                        {links.map(({ to, label }) => (
                            <li className="nav-item mx-0 mx-lg-1" key={to}>
                                <Link
                                    to={to}
                                    className="nav-link py-3 px-0 px-lg-3 rounded"
                                    aria-current={location.pathname === to ? 'page' : undefined}
                                    onClick={() => setIsMenuOpen(false)}
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
